const photoBarUploadingFormEquip = {
  typography: 'Espera a que se cargue el archivo'
};

export default photoBarUploadingFormEquip;
